export enum LicenseTypes {
    Admin = "admin",
    CommandCenterLicense = "4cd38ee4-faa5-4321-9d7e-38b3bf3c7868",
    Connector = "connector",
    Development = "development",
    DeviceLicensing = "device-licensing",
    HostDevice = "host-device",
    KioskDevice = "kiosk-device",
    Integrator = "integrator",
    KitchenDevice = "kitchen-device",
    OnDevice = "on-device",
    POS = "pos",
    PaymentProcessor = "payment-processor",
}
